import "metismenu";

$(document).on('ready page:load', function() {
  $(function() {
    $('#side-menu').metisMenu();
  });

});
